angular.module('dpw.components')
    .directive('dpwSyntaxHighlight', ['helpers', function (helpers) {
        hljs.configure({useBR: true});
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var language = attrs.dpwSyntaxHighlight;
                var original = element.html();
                var result = language ?
                    hljs.highlight(language, original) :
                    hljs.highlightAuto(original);
                var content = helpers.decodeEntities(result.value);

                element.html(content);
            }
        };
    }]);